<div class="card">
  <div class="card-body">
    <h5 class="card-title">{{model.Title}}</h5>
    <div class="cont__btn-help cont__btn-help_outline mb-3">
      <button type="button" (click)="viewActionGoalMatrix()" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="right" title="Matriz de objetivos de la acción" class="mt-1"></button>
    </div>

    <div class="range-date"><strong>Desde</strong> {{model.StartDate | date:'dd-MM-yyyy'}} / <strong>Hasta</strong> {{model.EndDate | date:'dd-MM-yyyy'}}</div>
  </div>
  <div class="card-footer bg-transparent">
    <div class="cont-footer d-flex justify-content-between">
      <p class="card-text m-0" *ngIf="model.IsOpen"><strong>Estado:</strong> En curso</p>
      <p class="card-text m-0" *ngIf="!model.IsOpen"><strong>Estado:</strong> Finalizado</p>
      <a (click)="downloadExcel(model.IdAction)" *ngIf="showDownloadLink" class="pointer white"><i class="fa fa-file-excel-o fa-lg" aria-hidden="true"></i>Descargar Informe</a>
    </div>
  </div>
</div>
<div class="row with-global-results-managers">
  <div class="col">
    <div style="text-align: center;" *ngIf="loading">
      <div>
        <img class="imageSize" src="assets/images/icons/ico_loading_bar.svg" />
      </div>
    </div>
    <div *ngIf="resultAction && !loading" class="py-4">
      <table class="table border-bottom mb-4">
        <tbody>
          <tr>
            <td class="fs-5"><strong>Total</strong></td>
            <td class="text-end fs-5"><strong>{{resultAction.TotalRemuneration | currency:'EUR'}}</strong></td>
          </tr>
        </tbody>
      </table>
      <table class="table table-striped table__resume">
        <thead>
          <tr>
            <th>Total subacciones</th>
            <th class="text-center">Unidades vendidas</th>
            <th class="text-end">Remuneración</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let subaction of resultAction.Subactions">
            <td>{{subaction.Title}}</td>
            <td class="text-center">{{subaction.TotalUnits}}</td>
            <td class="text-end">{{subaction.TotalRemuneration | currency:'EUR'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="global-results-managers">
    <h4 *ngIf="!loading && showManagers && modelSupervisor && modelSupervisor.length>0">Jefes de taller</h4>
    <ngb-accordion #acc="ngbAccordion" class="actions-accordion" *ngIf="model && showManagers">
      <ngb-panel *ngFor="let supervisor of modelSupervisor">
        <ng-template ngbPanelHeader>
          <button ngbPanelToggle class="accordion-button bg-light">
            <div class="col supervisor">
              <strong>{{supervisor.UserName}}</strong>
            </div>
            <div class="remuneracion">
              <span class="label_data">Remuneración</span><br>
              {{supervisor.TotalRemuneration | currency:'EUR'}}
            </div>
          </button>
        </ng-template>
        <ng-template ngbPanelContent>
          <strong>Receptores</strong>
          <div class="table__resume table-responsive-lg">
            <table class="table">
              <thead>
                <tr>
                  <th>Nombre completo</th>
                  <th>Subacción</th>
                  <th>Unidades vendidas</th>
                  <th>Remuneración</th>
                  <th>€/Unidades</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let receptor of supervisor.RenaultAnimationSubactionsUser">
                  <td>{{receptor.UserName}}</td>
                  <td>{{receptor.Title}}</td>
                  <td class="table-active">{{receptor.SoldUnits}}</td>
                  <td class="table-active">{{receptor.SoldTotalPrice | currency:'EUR'}}</td>
                  <td class="table-active">{{receptor.SoldPricePerUnit | currency:'EUR'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </div>
</div>